
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('vendor_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/Vendor/Create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('no') }}</th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Code')">{{ $t('code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Name')">{{ $t('khmer_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('NameEng')">{{ $t('latin_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Phone')">{{ $t('phone') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Email')">{{ $t('email') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Address')">{{ $t('address') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Website')">{{ $t('website') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('ContactName')">{{ $t('contact_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" >
                                    <span class="sort-field" @click="onSort('ContactPhone')">{{ $t('contact_number') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>
                                    <router-link :to="{name: 'vendor_update', params:{id:ret.Id}}">
                                        {{ret.Code}}
                                    </router-link>
                                </td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.NameEng}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{ret.Email}}</td>
                                <td>{{ret.Address}}</td>
                                <td>{{ret.Website}}</td>
                                <td>{{ret.ContactName}}</td>
                                <td>{{ret.ContactPhone}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25,
                SortType: '',
                SortField: ''
            },
            records:[],
            viewType: 0
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('vendor/list', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        viewTypeChange(n){
            this.viewType = n;
        },
        onSort(field){
            this.query.SortField = field;
            if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
            else this.query.SortType = 'ASC';
            this.toList();
        }
    }
}
</script>
